
import svg from "./assets/icons/arrow_left.svg";
import css from "./build/loaders/icon.scss";
import { h } from "preact"
export default function Icon() {
  return <span class={css("icon")} dangerouslySetInnerHTML={{__html: svg}}></span>;
}